import { OverlayTrigger, Popover } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { closePopover } from "./utils";
import { Button } from "./Button.tsx";

export function Confirmation({ children, title, actionFunction, actionParameter }) {
  const { t } = useTranslation();

  const overlay = (props) => {
    // useState does not work here because this is an inner function
    const doAction = (e) => {
      // not sure if using popper.state to pass parameters is future-proof
      const popperState = props.popper.state;
      if (popperState !== undefined) {
        e.currentTarget.disabled = true; // double-click prevention
        const { func, param } = popperState.options;
        const { reference } = popperState.elements; // reference to the element clicked inside OverlayTrigger
        closePopover();
        param !== undefined ? func(param) : func(reference); // call func with param if defined, else with reference
      }
    };

    return (
      <Popover {...props} id="popover-confirmation">
        <Popover.Header>{title}?</Popover.Header>
        <Popover.Body className="text-center" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button testId="no" variant="danger" onClick={closePopover}>
            {t("No", "Ei")}
          </Button>
          <Button testId="yes" variant="primary" className="me-2" onClick={doAction}>
            {t("Yes", "Kyllä")}
          </Button>
        </Popover.Body>
      </Popover>
    );
  };

  return (
    <OverlayTrigger
      trigger="click"
      placement="auto"
      rootClose
      overlay={overlay}
      popperConfig={{ func: actionFunction, param: actionParameter }}
    >
      {children}
    </OverlayTrigger>
  );
}
